<template>
    <div class="ContactDisplayAndEdit">
        <!--DISPLAY TABLE-->
        <b-container>
            <b-row style="overflow-x:auto;">
                <b-col cols="11">
                    <vuetable :fields="TableFields"
                              :data="TableData"
                              pagination-path=""
                              :api-mode="false"
                              class="vue-datatable"
                              :row-class="onRowClass">

                        <template slot="DetailView" scope="props">
                            <div class="DetailView">
                                <span class="underline pointer" @click="ShowDetailView(props.rowData)"><span v-html="props.rowData.EntityContact.Person.AKA ? props.rowData.EntityContact.Person.FirstName  + ' &quot;' + props.rowData.EntityContact.Person.AKA + '&quot; ' + props.rowData.EntityContact.Person.LastName  : props.rowData.EntityContact.Person.FullName"></span> <font-awesome-icon :icon="['fa', 'edit']" v-if="EditMode" /></span>
                            </div>
                        </template>
                    </vuetable>
                </b-col>
                <b-col cols="1">
                    <div v-if="EditMode" class="vert-icons">
                        <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddContact()" class="pointer olive-green-text" />
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <!--ADD AND EDIT AND DETAIL MODAL-->
        <b-modal ref="modal-contact" :title="ModalContactTitle" hide-footer :modal-class="IncludeCharting ? 'full-screen-modal' : ''" @show="ProfessionalDropdownEnabled == true ? GetAllContactsInSubProgram() : ''">
           
            <b-container v-if="!TargetContact.Id && ProfessionalDropdownEnabled">
                <b-row>
                    <b-col cols="12">
                        <b>Add Recent Professional</b>
                    </b-col>
                    <b-col cols="12">
                        <v-select  :options="Options"  v-model="selected" @input="setSelected(selected)"></v-select>
                    </b-col>
                </b-row>
            </b-container>
            <b-container v-if="EditMode == false && TargetContact.EntityContact">
                <b-row>

                    <b-col>
                        <h3>Name</h3>
                        <p><span class="bold">First Name: </span>{{ TargetContact.EntityContact.Person.FirstName }}</p>
                        <p v-if="TargetContact.EntityContact.Person.AKA"><span class="bold">AKA: </span>{{ TargetContact.EntityContact.Person.AKA }}</p>
                        <p v-if="TargetContact.EntityContact.Person.MiddleName"><span class="bold">Middle Name: </span>{{ TargetContact.EntityContact.Person.MiddleName }}</p>
                        <p><span class="bold">Last Name: </span>{{ TargetContact.EntityContact.Person.LastName }}</p>
                        <p v-if="TargetContact.EntityContact.Person.Suffix"><span class="bold">Suffix: </span>{{ TargetContact.EntityContact.Person.Suffix }}</p>
                    </b-col>
                    <b-col v-if="!HidePersonalInfo">
                        <h3>Personal Info</h3>
                        <p v-if="TargetContact.EntityContact.Person.DOB"><span class="bold">DOB: </span>{{ formatDate(TargetContact.EntityContact.Person.DOB,'MM/DD/YY') }}</p>
                        <p v-if="TargetContact.EntityContact.Person.DOB"><span class="bold">Age: </span>{{ TargetContact.EntityContact.Person.AgeString }}</p>
                        <p v-if="TargetContact.EntityContact.Person.SSN"><span class="bold">SSN: </span>{{ TargetContact.EntityContact.Person.FormattedSSN }}</p>
                        <h3>Demographics</h3>
                        <p v-if="TargetContact.EntityContact.Person.Sex"><span class="bold">Sex: </span>{{ TargetContact.EntityContact.Person.Sex.Name }}</p>
                        <p v-if="TargetContact.EntityContact.Person.Race"><span class="bold">Race: </span>{{ TargetContact.EntityContact.Person.Race.Name }}</p>
                        <p v-if="TargetContact.EntityContact.Person.Ethnicity"><span class="bold">Ethnicity: </span>{{ TargetContact.EntityContact.Person.Ethnicity.Name }}</p>
                    </b-col>
                </b-row>
                <b-row v-if="IncludePnwFamilyTracking">
                    <b-col>
                        <h3>Background/Clearances</h3>
                        <p><span class="bold">Background Check (16): </span>{{ TargetContact.EntityContact.Person.BC16Obtained != null ? TargetContact.EntityContact.Person.BC16Obtained == true ? 'Yes' : 'No' : '' }}</p>
                        <p><span class="bold">Background Check (18): </span>{{ TargetContact.EntityContact.Person.BC18Obtained != null ? TargetContact.EntityContact.Person.BC18Obtained == true ? 'Yes' : 'No' : '' }}</p>
                        <p><span class="bold">Fingerprints Obtained: </span>{{ TargetContact.EntityContact.Person.FingerPrintsObtained != null ? TargetContact.EntityContact.Person.FingerPrintsObtained == true ? 'Yes' : 'No' : '' }}</p>
                    </b-col>
                    <b-col>
                        <h3>Vaccinations/Tests</h3>
                        <p><span class="bold">Last Flu Shot: </span>{{ formatDate(TargetContact.EntityContact.Person.FluShotDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Last Pertussis: </span>{{ formatDate(TargetContact.EntityContact.Person.PertussisDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Last TB Test: </span>{{ formatDate(TargetContact.EntityContact.Person.TBVaccinationDate,'MM/DD/YY') }}</p>
                    </b-col>
                </b-row>
                <b-row v-if="IncludePnwBabysitterTracking">
                    <b-col>
                        <h3>Document Dates</h3>
                        <p><span class="bold">DL Expiration: </span>{{ formatDate(TargetContact.EntityContact.Person.DriverLicenseExpirationDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">CPR Expiration: </span>{{ formatDate(TargetContact.EntityContact.Person.CPRExpirationDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">First Aid Expiration: </span>{{ formatDate(TargetContact.EntityContact.Person.FirstAidExpirationDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Car Insurance Expiration: </span>{{ formatDate(TargetContact.EntityContact.Person.CarInsuranceExpirationDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Policy Agreement Signed: </span>{{ formatDate(TargetContact.EntityContact.Person.PolicyAgreementSignedDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Fingerprint Notice: </span>{{ formatDate(TargetContact.EntityContact.Person.FingerPrintNoticeDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">BCCU Sent: </span>{{ TargetContact.EntityContact.Person.BCCUSent != null ? TargetContact.EntityContact.Person.BCCUSent == true ? 'Yes' : 'No' : '' }}</p>
                        <p><span class="bold">BCCU Cleared Date: </span>{{ formatDate(TargetContact.EntityContact.Person.BCCUClearedDate,'MM/DD/YY') }}</p>
                    </b-col>
                    <b-col>
                        <h3>Vaccinations/Tests</h3>
                        <p><span class="bold">Last Flu Shot: </span>{{ formatDate(TargetContact.EntityContact.Person.FluShotDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Last Pertussis: </span>{{ formatDate(TargetContact.EntityContact.Person.PertussisDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Last TB Test: </span>{{ formatDate(TargetContact.EntityContact.Person.TBVaccinationDate,'MM/DD/YY') }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h3>Contact Info</h3>
                        <p v-if="TargetContact.EntityContact.Person.Email"><span class="bold">Email: </span>{{ TargetContact.EntityContact.Person.Email }}</p>
                        <p v-for="(phoneNumber, phoneIndex) in TargetContactPhoneNumbers">
                            <span class="bold">{{ phoneNumber.PhoneType }}: </span>{{ phoneNumber.PhoneNumber }} {{ phoneNumber.Description ? '(' + phoneNumber.Description + ')' : '' }}
                        </p>
                    </b-col>
                </b-row>
                <b-row v-if="IsStrongFamilyContactable">
                    <b-col>
                        <h3>Contact Preferences</h3>
                        <p><span class="bold">Text Messages: </span>{{TargetContact.EntityContact.Person.IsSMSContactOk ? "Yes" : "No"}}</p>
                        <p><span class="bold">Email: </span>{{TargetContact.EntityContact.Person.IsEmailContactOk ? "Yes" : "No"}}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h3>Assignment Details</h3>
                        <p><span class="bold">Contact Type: </span>{{ TargetContact.EntityContact.ContactCategory }}</p>
                        <p v-if="TargetContact.EntityContact.Agency"><span class="bold" v-if="DisplayChurch == true">Church: </span><span class="bold" v-else>Agency: </span>{{ TargetContact.EntityContact.Agency }}</p>
                        <p><span class="bold">Relationship to {{ RelationshipLabel }}: </span>{{ TargetContact.ContactRelationship }}</p>
                        <p><span class="bold">Start Date: </span>{{ formatDate(TargetContact.StartDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">End Date: </span>{{ formatDate(TargetContact.EndDate,'MM/DD/YY') }}</p>
                    </b-col>
                </b-row>
                <b-row v-if="IncludeCharting">
                    <CaseFile chart-type="EntityContact"
                              :chart-record-id="TargetContact.EntityContact.Id" />
                </b-row>
                <b-row class="modal-btn-row">
                    <div class="modal-btn-row-div">
                        <b-button size="md" variant="secondary" @click="CancelContact()">
                            CLOSE
                        </b-button>
                    </div>
                </b-row>
            </b-container>
            <b-container v-if="EditMode">
                <b-form @submit="AddEditContact">
                    <PersonEditor :edit-mode="true"
                                  :existing-person="TargetContact.EntityContact ? TargetContact.EntityContact.Person : null"
                                  :DOBRequired="RequireDob"
                                  :global-update="GlobalUpdate"
                                  :inline="true"
                                  end-point="tbd"
                                  :control-buttons="false"
                                  :include-pnw-family-tracking="IncludePnwFamilyTracking"
                                  :include-pnw-babysitter-tracking="IncludePnwBabysitterTracking"
                                  :hide-personal-info="HidePersonalInfo"
                                  ref="contact-add-editor"
                                  :is-strong-family-contactable="IsStrongFamilyContactable"/>
                    <b-row>
                        <b-col>
                            <h3>Assignment Details</h3>
                            <div class="form-group" v-if="AgencyInput && TargetContact.EntityContact">
                                <label>Agency:</label>
                                <input class="form-control" v-model="TargetContact.EntityContact.Agency" />
                            </div>
                            <div class="form-group" v-if="DisplayChurch && TargetContact.EntityContact">
                                <label>Church:</label>
                                <input class="form-control" v-model="TargetContact.EntityContact.Agency" />
                            </div>
                            <div class="form-group">
                                <label>Relationship to {{ RelationshipLabel }}:</label>
                                <div v-if="Array.isArray(RelationshipOptions)">
                                    <select class="form-control" v-model="TargetContact.ContactRelationship" required>
                                        <option v-for="option in RelationshipOptions" :value="option.value">{{ option.text }}</option>
                                    </select>
                                </div>
                                <div v-else-if="RelationshipOptions">
                                    <input class="form-control" required v-model="TargetContact.ContactRelationship" readonly />
                                </div>
                                <div v-else>
                                    <input class="form-control" required v-model="TargetContact.ContactRelationship" />
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Start Date:</label>
                                <flat-pickr v-model="TargetContact.StartDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>End Date:</label>
                                <flat-pickr v-model="TargetContact.EndDate" class="form-control" :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-if="TargetContact.Id && IncludeCharting">
                        <b-col>
                            <h3>Add Document</h3>
                            <NewDocument :form-memberships="ContactFormMemberships"
                                         :chart-record-id="TargetContact.EntityContact.Id" />
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelContact()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit" v-if="EditMode">
                                SAVE
                            </b-button>
                            <b-button size="md" variant="danger" @click="DeleteContact()" type="button" v-if="TargetContact.Id">
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>

</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    import NewDocument from "../RecordComponents/NewDocument.vue";
    import CaseFile from "../RecordComponents/CaseFile.vue";
    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import PersonEditor from './PersonEditor.vue';
    import { EventBus } from '../../../services/event-bus.js';

    export default {
        props: [
            "EditMode",//bool
            "GlobalUpdate",//bool
            "DispatchOnSuccess",//string[]
            "GetEndpoint",//string
            "GetPayload",//object
            "AddEditEndpoint",//string
            "AddEditPayload",//object
            "DeleteEndpoint",//string
            "DeletePayload",//object
            "DeleteWarning",//string
            "DisplayAgency",//bool
            "DisplayAge",//bool
            "DisplayRelationship",//bool
            "AgencyInput", //bool
            "ChurchInput", //bool
            "DisplayAgency",//bool
            "DisplayChurch",//bool
            "RequireDob",//bool
            "ContactCategory",//string
            "RelationshipOptions",//array or string or null
            "RelationshipLabel",//string
            "IncludeCharting",//bool
            "SubProgramId",//string
            "ProfessionalDropdownEnabled", //bool
            "ProfessionalDropdownEnabledPayload", //object
            "ProfessionalDropdownEnabledEndpoint", //string
            "IncludePnwFamilyTracking",//bool
            "IncludePnwBabysitterTracking",//bool
            "HidePersonalInfo",//bool
            "IsStrongFamilyContactable"//bool
        ],
        data: function () {
            return {
                selected: [],
                TargetContact: {},
                ModalContactTitle: "",
                LoadedRecords: [],//Contact Membership Records
                Options: [],
                ContactSchema: {
                    Id: "",
                    StartDate: "",
                    EndDate: "",
                    ContactRelationship: "",
                    EntityContactID: "",
                    EntityContact: {
                        Id: "",
                        ContactCategory: "",
                        Agency: "",
                        PersonID: "",
                        Person: {
                            FirstName: "",
                            LastName: "",
                            MiddleName: "",
                            Suffix: "",
                            Prefix: "",
                            AKA: "",
                            DOB: "",
                            SexID: "",
                            RaceID: "",
                            EthnicityID: "",
                            Email: "",
                            PhoneNumbers: [],
                            DriverLicenseExpirationDate: "",
                            CPRExpirationDate: "",
                            FirstAidExpirationDate: "",
                            HIVDate: "",
                            CarInsuranceExpirationDate: "",
                            FluShotDate: "",
                            PertussisDate: "",
                            TBVaccinationDate: "",
                            BC16Obtained: "",
                            BC18Obtained: "",
                            FingerPrintsObtained: "",
                            PolicyAgreementSignedDate: "",
                            FingerPrintNoticeDate: "",
                            BCCUClearedDate: "",
                            BCCUSent: "",
                            IsSMSContactOk: "",
                            IsEmailContactOk: ""
                        }
                    }
                },
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false  
                }
                
            };
        },
        methods: {
            onRowClass (dataItem, index) {
                return (dataItem.EndDate == null) ? 'current-record' : '';
            },
            GetContacts() {
                    this.$MasterAPI.ExecuteRequest("GET", this.GetEndpoint, this.GetPayload, this.GetContactsSuccess, () => { }, false);

            },
            GetContactsSuccess(response) {
                this.LoadedRecords = response.data.data;
            },
            GetAllContactsInSubProgram() {
                this.$MasterAPI.ExecuteRequest("GET", this.ProfessionalDropdownEnabledEndpoint, this.ProfessionalDropdownEnabledPayload, this.GetAllContactsInSubProgramSuccess, () => { }, false);
            },
            GetAllContactsInSubProgramSuccess(response) {
                let vm = this;
                vm.Options = [];
                vm.selected = null;
                let distinctArray = [];
                response.data.data.filter(function (item) {
                    var i = distinctArray.findIndex(x => (x.EntityContact.Person.FullName == item.EntityContact.Person.FullName && x.ContactRelationship == item.ContactRelationship && x.EntityContact.Agency == item.EntityContact.Agency));
                    if(i <= -1){
                        distinctArray.push(item);
                    }
                    return null;
                });
                for (var i = 0; i < distinctArray.length; i++) {
                    vm.Options.push
                        ({
                            "Id": distinctArray[i].EntityContactID,
                            "label": distinctArray[i].EntityContact.Person.FullName + " - " + distinctArray[i].ContactRelationship + " - " + distinctArray[i].EntityContact.Agency,
                            "Record": distinctArray[i]
                        })
                }
            },
            ShowDetailView(contact) {
                this.TargetContact = JSON.parse(JSON.stringify(contact));
                
                if (this.EditMode) {
                    this.ModalContactTitle = "Editing " + contact.EntityContact.Person.FullName;
                } else {
                    this.ModalContactTitle = "Viewing " + contact.EntityContact.Person.FullName;
                }
                this.$refs["modal-contact"].show();
            },
            ShowAddContact() {
                this.TargetContact = JSON.parse(JSON.stringify(this.ContactSchema));
                this.ModalContactTitle = "Add New " + this.ContactCategory;
                if (!Array.isArray(this.RelationshipOptions) && this.RelationshipOptions) {
                    this.TargetContact.ContactRelationship = this.RelationshipOptions;
                }
                this.$refs["modal-contact"].show();
            },
            AddEditContact(e) {
                e.preventDefault();
                //get person data here
                this.TargetContact.EntityContact.Person = this.$refs["contact-add-editor"].GetUpdatedPerson();
                this.$MasterAPI.ExecuteRequest("POST", this.AddEditEndpoint,{ ...this.TargetContact, ...this.AddEditPayload }, this.AddEditContactSuccess, () => { }, true);

            },
            AddEditContactSuccess(response) {
                this.GetContacts();
                this.$refs["modal-contact"].hide();
            },
            DeleteContact() {
                this.$MasterAPI.ExecuteRequest("POST", this.DeleteEndpoint, { Id: this.TargetContact.Id }, this.DeleteContactSuccess, () => { }, true);

            },
            DeleteContactSuccess(response) {
                this.GetContacts();
                this.$refs["modal-contact"].hide();
            },
            CancelContact() {
                this.selected = {};
                this.$refs['modal-contact'].hide();
            },
            CancelDelete() {
                this.$refs['modal-delete'].hide();
            },
            formatDate (value, fmt = 'D MMM YYYY') {
              return (value == null || value == '')
                ? ''
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            setSelected(value) {
                //If user clicked on x to remove professional, go to else without error.
                if (value == null) {
                    value = {};
                }
                if ("Record" in value) {
                    this.$refs["contact-add-editor"].UpdatedPerson.FirstName = value.Record.EntityContact.Person.FirstName;
                    this.$refs["contact-add-editor"].UpdatedPerson.AKA = value.Record.EntityContact.Person.AKA;
                    this.$refs["contact-add-editor"].UpdatedPerson.MiddleName = value.Record.EntityContact.Person.MiddleName;
                    this.$refs["contact-add-editor"].UpdatedPerson.LastName = value.Record.EntityContact.Person.LastName;
                    this.$refs["contact-add-editor"].UpdatedPerson.Suffix = value.Record.EntityContact.Person.Suffix;
                    this.$refs["contact-add-editor"].UpdatedPerson.DOB = value.Record.EntityContact.Person.DOB;
                    this.$refs["contact-add-editor"].UpdatedPerson.SSN = value.Record.EntityContact.Person.SSN;
                    this.$refs["contact-add-editor"].UpdatedPerson.SexID = value.Record.EntityContact.Person.SexID;
                    this.$refs["contact-add-editor"].UpdatedPerson.RaceID = value.Record.EntityContact.Person.RaceID;
                    this.$refs["contact-add-editor"].UpdatedPerson.EthnicityID = value.Record.EntityContact.Person.EthnicityID;
                    this.$refs["contact-add-editor"].UpdatedPerson.Email = value.Record.EntityContact.Person.Email;
                    this.$refs["contact-add-editor"].UpdatedPerson.IsSMSContactOk = value.Record.EntityContact.Person.IsSMSContactOk;
                    this.$refs["contact-add-editor"].UpdatedPerson.IsEmailContactOk = value.Record.EntityContact.Person.IsEmailContactOk;
                    this.TargetContact.EntityContact.Agency = value.Record.EntityContact.Agency;
                    this.TargetContact.ContactRelationship = value.Record.ContactRelationship;
                    this.TargetContact.StartDate = "";
                    this.TargetContact.EndDate = "";
                    for (var i = 0; i < value.Record.EntityContact.Person.PhoneNumbers.length; i++) {
                        this.$refs["contact-add-editor"].UpdatedPerson.PhoneNumbers[i] =
                            ({
                                "Description": value.Record.EntityContact.Person.PhoneNumbers[i].PhoneNumber.Description,
                                "PhoneNumber": value.Record.EntityContact.Person.PhoneNumbers[i].PhoneNumber.FormattedPhoneNumber,
                                "PhoneType": value.Record.EntityContact.Person.PhoneNumbers[i].PhoneNumber.PhoneType
                            });
                    }
                }
                //remove info
                else {
                    this.$refs["contact-add-editor"].UpdatedPerson.FirstName = "";
                    this.$refs["contact-add-editor"].UpdatedPerson.AKA = "";
                    this.$refs["contact-add-editor"].UpdatedPerson.MiddleName = "";
                    this.$refs["contact-add-editor"].UpdatedPerson.LastName = "";
                    this.$refs["contact-add-editor"].UpdatedPerson.Suffix = "";
                    this.$refs["contact-add-editor"].UpdatedPerson.DOB = "";
                    this.$refs["contact-add-editor"].UpdatedPerson.SSN = "";
                    this.$refs["contact-add-editor"].UpdatedPerson.SexID = "";
                    this.$refs["contact-add-editor"].UpdatedPerson.RaceID = "";
                    this.$refs["contact-add-editor"].UpdatedPerson.EthnicityID = "";
                    this.$refs["contact-add-editor"].UpdatedPerson.Email = "";
                    this.$refs["contact-add-editor"].UpdatedPerson.IsSMSContactOk = "";
                    this.$refs["contact-add-editor"].UpdatedPerson.IsEmailContactOk = "";
                    this.TargetContact.EntityContact.Agency = "";
                    this.TargetContact.ContactRelationship = "";
                    this.TargetContact.StartDate = "";
                    this.TargetContact.EndDate = "";
                    this.$refs["contact-add-editor"].UpdatedPerson.PhoneNumbers = []
                }
            }
            
        },
        components: {
            flatPickr,
            Vuetable,
            PersonEditor,
            NewDocument,
            CaseFile,
            vSelect
        },
        computed: {
            TableFields: function () {
                let vm = this;
                let fieldData = [
                    {
                        name: "__slot:DetailView",
                        title: "NAME"
                    }
                ];

                if (vm.DisplayRelationship) {
                    fieldData.push( 
                        {
                            name: "ContactRelationship",
                            title: "RELATIONSHIP"
                        }
                    );
                }
                if (vm.DisplayAgency) {
                    fieldData.push( 
                        {
                            name: "EntityContact.Agency",
                            title: "AGENCY"
                        }
                    );
                }
                if (vm.DisplayChurch) {
                    fieldData.push( 
                        {
                            name: "EntityContact.Agency",
                            title: "CHURCH"
                        }
                    );
                }
                if (vm.DisplayAge) {
                    fieldData.push( 
                        {
                            name: "EntityContact.Person.AgeString",
                            title: "AGE"
                        }
                    );
                }
                

                fieldData.push(
                    {
                        name: "StartDate",
                        title: "STARTED",
                        callback: 'formatDate|MM/DD/YY',
                    }
                );
                fieldData.push(
                    {
                        name: "EndDate",
                        title: "ENDED",
                        callback: 'formatDate|MM/DD/YY',
                    }
                );
                return fieldData;
            },
            TableData: function () {
                return this.LoadedRecords;
            },
            TargetContactPhoneNumbers: function () {
                let phoneNumbers = [];
                if (this.TargetContact.EntityContact) {
                    this.TargetContact.EntityContact.Person.PhoneNumbers.forEach(function (item) {
                        if (item.EndDate == null) {
                            phoneNumbers.push({
                                MembershipID: item.Id,
                                PhoneNumber: item.PhoneNumber.FormattedPhoneNumber,
                                PhoneType: item.PhoneNumber.PhoneType,
                                Description: item.PhoneNumber.Description
                            });
                        }
                    });
                }
                return phoneNumbers;
                
            },
            ContactFormMemberships: function () {
                let subProgram = this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgram"](this.SubProgramId);
                return subProgram.FormMemberships.filter(fm => fm.ChartType == "EntityContact");
            },
            
        },
        mounted() {
            this.GetContacts();
        },

    }
</script>

<style scoped>
    .vert-icons div {
        margin-top:10px;
    }
    /deep/ tbody tr.current-record {
        font-weight: bold;
    }
    table {
        table-layout:auto;
    }
    .vue-datatable {
        width: 100%;
        display: inline-table;
        overflow-x: auto;
    }
</style>